import { mapEnumToOptions } from '@abp/ng.core';

export enum IsNewTenantCh {
  Yes = 0,
  No = 1,
  Eligible = 2,
}

export const isNewTenantChOptions = mapEnumToOptions(IsNewTenantCh);
